import { registerRootComponent } from "expo";
import "./src/utils/Translations/i18nBootstrap";
import App from "./App";
// polyfills/back-handler.ts
import { BackHandler } from "react-native";

if (!BackHandler.removeEventListener) {
  BackHandler.removeEventListener = () => {
    // no‑op shim for RN ≥ 0.77
  };
}

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
